import * as Yup from 'yup'

export const formSchema = Yup.object().shape({
  active: Yup.bool().required('Active is required.'),
  content: Yup.string().required('Each Scheduled Communication Template requires content.'),
})

export interface FormValuesType {
  active: boolean
  content: string
}
